import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Accordion, AccordionDetails, AccordionSummary, Card, CardContent, Grid, Typography } from "@material-ui/core";

import expressServiceStyles from "../ExpressStyles";

import OverlayLoader from "../../../common/Loader/OverlayLoader";
import PageTitle from "../../../common/PageTitle/PageTitle";
import CustomAlert from "../../../common/CustomAlert/CustomAlert";
import RenderExpressConfigurationSlotsAccordion from "./common/RenderExpressConfigurationSlotsAccordion";
import BulkUpdateExpressPopUp from "../common/BulkUpdateExpressPopUp";

import { ALERT_TYPES, APP_ROUTES, TEXT_CONSTANT } from "../../../../config/constants";
import { check_if_slot_obj_contains_sub_set } from "../../../../utils/ApplicationUtils";
import { fetchPOSDetailsByPOSNo } from "../../../CreatePOS/redux/posSlice";
import { selectServiceTypes } from "../../../../config/redux/configurationsSlice";
import { fetchPendingApprovalRequest } from "../../../ApprovalRequest/Redux/ApprovalRequestSlice";
import { fetchSlotsInformationByServiceType, resetSlotsInformation, sendConfigurationForApproval } from "../../../ServiceAndSlots/redux/templateSlotsSlice";
import {
  _validate_send_for_approval_form,
  add_new_template_slot_util,
  bulk_update_slot_changes_util,
  delete_template_slot_util,
  design_express_configuration_handler_utils,
  update_handle_individual_slot_field_change,
  update_make_slot_editable,
  validate_generator_form_before_bulk_update,
} from "./common/Utils/NewExpressRequestUtils";
import RenderFooterButtons from "components/ServiceAndSlots/Standard/NewApprovalRequest/common/RenderFooterButtons";
import { ExpandMoreAccordianIcon } from "components/common/App/AppViewUtils";
import CustomTextArea from "components/common/TextBoxWithLabel/CustomTextArea";
import { isArrayValid, isEmptyOrNull, isNonEmptyObject } from "../../../../utils/DataUtils";

interface NewExpressRequestInterface {
  serviceTypeId: any;
  serviceTypeName: any;
}

const NewExpressRequest = (props: NewExpressRequestInterface) => {
  const { serviceTypeId, serviceTypeName } = props;

  const { posNo, zoneId }: any = useParams();
  const dateObject = {
    activationDate: "",
    activationDatelabel: "",
    isDateValid: false,
    data_present_obj: {},
  } as any;

  const classes: any = expressServiceStyles();
  const navigate = useNavigate();
  const appDispatch = useDispatch();

  const { posDetails, loading: fetchingDetails, fetching: fetchingPosDetails } = useSelector((state: any) => state.pos);
  const { fetchingSlots, express } = useSelector((state: any) => state.slots);
  const serviceTypes = useSelector(selectServiceTypes);
  const {
    currentCountry: { countryId },
  } = useSelector((state: any) => state.appConfig);

  const [configTab, setConfigTab] = useState({} as any);
  const [originalConfigTab, setOriginalConfigTab] = useState({} as any);
  const [stateObj, setStateObj] = useState({
    loading: false,
    selectedConfigTab: 0,
    request_already_presnt_by_admin_error: "",
    // Bulk Update
    openBulkUpdateConfirmationPopUp: false,
    configTabIndex: null,
    generatorFormIndex: null,
    configuredDays: [],
    currentBulkUpdateConfigurationSummary: {},
    selctedDays: [],
    currentDay: "",
    configurationBulkUpdatedObj: {
      isConfigurationBulkUpdated: false,
      bulkUpdatedDays: [],
    },
    approverComment: "",
  } as any);

  const makeSlotEditable = (generatorFormIndex: any, slot_index: any) => {
    if (!isEmptyOrNull(generatorFormIndex) && generatorFormIndex >= 0 && !isEmptyOrNull(slot_index) && slot_index >= 0) {
      let new_config_tab = update_make_slot_editable(configTab, generatorFormIndex, slot_index);
      setConfigTab(new_config_tab);
    }
  };

  const handleOnDemandServiceTimeChange = (generatorFormIndex: any, slot_index: any, selected_date: any, input_name: any) => {
    if (!isEmptyOrNull(selected_date) && !isEmptyOrNull(input_name)) {
      let new_config_tab = update_handle_individual_slot_field_change(configTab, generatorFormIndex, slot_index, input_name, selected_date);
      setConfigTab(new_config_tab);
    }
  };

  const handleIndividualSlotFieldsChange = (generatorFormIndex: any, slot_index: any, event: any) => {
    if (!isEmptyOrNull(event?.target)) {
      const { name, value } = event.target;
      let new_config_tab = update_handle_individual_slot_field_change(configTab, generatorFormIndex, slot_index, name, value);
      setConfigTab(new_config_tab);
    }
  };

  const addNewTemplateSlot = (generatorFormIndex: any, days: any) => {
    if (!isEmptyOrNull(generatorFormIndex) && generatorFormIndex >= 0) {
      if (!isEmptyOrNull(configTab?.zoneId)) {
        let new_config_tab = add_new_template_slot_util(configTab, generatorFormIndex, configTab.zoneId, days, posDetails);
        setConfigTab(new_config_tab);
      } else {
        CustomAlert(ALERT_TYPES.ERROR, "Internal error : No Zone Id found.");
      }
    }
  };

  const deleteTemplateSlot = (generatorFormIndex: any, slot_index: any) => {
    if (!isEmptyOrNull(generatorFormIndex) && generatorFormIndex >= 0 && !isEmptyOrNull(slot_index) && slot_index >= 0) {
      let new_config_tab = delete_template_slot_util(configTab, generatorFormIndex, slot_index);
      setConfigTab(new_config_tab);
    }
  };

  const handleBulkUpdateAction = (generatorFormIndex: any) => {
    if (isEmptyOrNull(generatorFormIndex) || generatorFormIndex < 0) {
      return;
    }

    const is_all_slots_valid = validate_generator_form_before_bulk_update(configTab);
    if (is_all_slots_valid !== true) {
      return;
    }

    const slotsGeneratorForms = configTab?.slotsGeneratorForms;
    const selectedGeneratorForm = slotsGeneratorForms?.[generatorFormIndex];
    if (!isArrayValid(slotsGeneratorForms) || isEmptyOrNull(selectedGeneratorForm?.generatedSlots)) {
      return;
    }

    const is_slot_obj_valid = check_if_slot_obj_contains_sub_set(selectedGeneratorForm.generatedSlots);
    if (isNonEmptyObject(is_slot_obj_valid)) {
      CustomAlert(ALERT_TYPES.ERROR, is_slot_obj_valid[Object.keys(is_slot_obj_valid)[0]]);
      return;
    }

    const currentDay = selectedGeneratorForm?.days[0];
    const allDays = slotsGeneratorForms.flatMap((slot: any) =>
      isArrayValid(slot?.days) && slot.days[0] !== currentDay
        ? slot.days
        : []
    );

    let generatedForm = { ...selectedGeneratorForm };
    if (isArrayValid(generatedForm?.generatedSlots)) {
      generatedForm.generatedSlots = generatedForm.generatedSlots.filter(
        (slot: any) => !isEmptyOrNull(slot?.slotAction) && slot?.slotAction !== "DELETE"
      );
    }

    setStateObj({
      ...stateObj,
      loading: true,
      openBulkUpdateConfirmationPopUp: true,
      generatorFormIndex: generatorFormIndex,
      configuredDays: allDays,
      currentBulkUpdateConfigurationSummary: generatedForm,
      selctedDays: [],
      currentDay: currentDay,
      configurationBulkUpdatedObj: {
        isConfigurationBulkUpdated: false,
        bulkUpdatedDays: [],
      },
    });
  };

  const handleCloseBulkUpdateConfimationPopUp = () => {
    setStateObj({
      ...stateObj,
      loading: false,
      openBulkUpdateConfirmationPopUp: false,
      generatorFormIndex: "",
      configuredDays: [],
      currentBulkUpdateConfigurationSummary: {},
      selctedDays: [],
      currentDay: "",
      configurationBulkUpdatedObj: {
        isConfigurationBulkUpdated: false,
        bulkUpdatedDays: [],
      },
    });
  };

  const clearBulkUpdatedConfimationPopUpObj = (days: any) => {
    setStateObj({
      ...stateObj,
      loading: false,
      openBulkUpdateConfirmationPopUp: false,
      generatorFormIndex: "",
      configuredDays: [],
      currentBulkUpdateConfigurationSummary: {},
      selctedDays: [],
      currentDay: "",
      configurationBulkUpdatedObj: {
        isConfigurationBulkUpdated: true,
        bulkUpdatedDays: [...days],
      },
    });
  };

  const updateStandardServiceStateSelctedDays = (selectedDaysCopy: any) => {
    setStateObj({ ...stateObj, selctedDays: selectedDaysCopy });
  };

  const handleDaySelectedForBulkUpdate = (dayValue: any) => {
    if (isEmptyOrNull(dayValue)) {
      return;
    }

    const selectedDaysCopy: any = [...stateObj.selctedDays];
    if (!isArrayValid(selectedDaysCopy)) {
      return;
    }

    if (dayValue === TEXT_CONSTANT.ALL) {
      if (selectedDaysCopy.length === stateObj?.configuredDays?.length) {
        updateStandardServiceStateSelctedDays([]);
      } else {
        updateStandardServiceStateSelctedDays([...stateObj.configuredDays]);
      }
    } else {
      const isElementPresent = selectedDaysCopy.indexOf(dayValue);
      if (isElementPresent > -1) {
        selectedDaysCopy.splice(isElementPresent, 1);
      } else {
        selectedDaysCopy.push(dayValue);
      }
      updateStandardServiceStateSelctedDays(selectedDaysCopy);
    }
  };

  const handleBulkUpdateConfirmAction = () => {
    if (isArrayValid(stateObj?.selctedDays)) {
      const slotsGeneratorForms = configTab?.slotsGeneratorForms;
      const selectedGeneratorForm = slotsGeneratorForms?.[stateObj?.generatorFormIndex];
      if (isArrayValid(slotsGeneratorForms) && !isEmptyOrNull(selectedGeneratorForm) && isNonEmptyObject(stateObj?.currentBulkUpdateConfigurationSummary)) {
        const slotForm = JSON.parse(JSON.stringify(stateObj.currentBulkUpdateConfigurationSummary));
        if (isArrayValid(slotForm?.generatedSlots)) {
          let new_config_tab = bulk_update_slot_changes_util(configTab, stateObj.currentDay, stateObj.selctedDays, slotForm);
          setConfigTab(new_config_tab);
          clearBulkUpdatedConfimationPopUpObj(stateObj.selctedDays);
        }
      }
    } else {
      CustomAlert(ALERT_TYPES.ERROR, TEXT_CONSTANT.BULK_UPDATE_NO_DAYS_SELECTED);
    }
  };

  const resetCurrentConfigurationAfterBulkUpdateRevert = () => {
    if (isArrayValid(express)) {
      designExpressConfigurationsHandler(express);
    }
  };

  const call_send_for_approval = async (payload_Object: any) => {
    const { payload }: any = await appDispatch(sendConfigurationForApproval(payload_Object));
    if (payload?.response?.data === "success") {
      CustomAlert(ALERT_TYPES.SUCCESS, `Configuration was successfully sent for approval.`);
      appDispatch(
        fetchPendingApprovalRequest({
          countryId: countryId,
          status: ["PENDING"],
        })
      );
      navigate(APP_ROUTES.POS_LIST);
    } else {
      setStateObj({ ...stateObj, loading: false });
      let errorMessage = "Error Occurred";
      if (payload?.message !== "No message available") {
        errorMessage = payload.message;
      }
      CustomAlert(ALERT_TYPES.ERROR, errorMessage);
    }
  };

  const send_request_for_approval = () => {
    setStateObj({ ...stateObj, loading: true });
    if (!isEmptyOrNull(dateObject?.activationDate)) {
      const pay_load_object = _validate_send_for_approval_form(originalConfigTab, configTab, dateObject, countryId, stateObj);
      if (isNonEmptyObject(pay_load_object)) {
        call_send_for_approval(pay_load_object);
      } else {
        setStateObj({ ...stateObj, loading: false });
      }
    } else {
      CustomAlert(ALERT_TYPES.ERROR, "Please provide implementation date.");
      setStateObj({ ...stateObj, loading: false });
    }
  };

  const designExpressConfigurationsHandler = (slots: any) => {
    if (!isEmptyOrNull(zoneId)) {
      const new_config_tabs = design_express_configuration_handler_utils(slots, zoneId);
      setOriginalConfigTab(new_config_tabs);
      setConfigTab(new_config_tabs);
      setStateObj({ ...stateObj, loading: false, configurationBulkUpdatedObj: { isConfigurationBulkUpdated: false, bulkUpdatedDays: [] } });
    }
  };

  const handleCommentInputChange = (event: any) => {
    if (!isEmptyOrNull(event?.target)) {
      const { value } = event.target;
      if (!isEmptyOrNull(value) && value?.length > 200) {
        return;
      } else {
        setStateObj({ ...stateObj, approverComment: value });
      }
    }
  };

  const fetchSlots = () => {
    appDispatch(fetchSlotsInformationByServiceType({ posNo, serviceType: serviceTypeId, serviceTypeName }));
  };

  useEffect(() => {
    if (isArrayValid(express)) {
      designExpressConfigurationsHandler(express);
      appDispatch(
        fetchPendingApprovalRequest({
          countryId: countryId,
          status: ["PENDING"],
        })
      );
    }
  }, [express]);

  useEffect(() => {
    // Refetch whenever the URL POS differs from the cached posDetails, so a stale
    // POS (from a prior editor visit) can never leak its posId/serviceTypeMappingId
    // into this POS's write payload (DOS-3285).
    if (posNo && String(posDetails?.posNo) !== String(posNo) && serviceTypes.length) {
      appDispatch(fetchPOSDetailsByPOSNo(posNo));
    }
  }, [appDispatch, posNo, serviceTypeId, serviceTypeName, posDetails.posNo, serviceTypes.length]);

  useEffect(() => {
    if (!isEmptyOrNull(posNo) && !isEmptyOrNull(serviceTypeId)) {
      fetchSlots();
    }
  }, [appDispatch, posNo, serviceTypeId, serviceTypeName]);

  useEffect(() => {
    return () => {
      appDispatch(resetSlotsInformation());
    };
  }, [appDispatch]);

  return (
    <>
      <Grid container spacing={0} className={classes.mainContentSection}>
        <OverlayLoader loading={fetchingSlots || stateObj.loading || fetchingDetails || fetchingPosDetails} />
        {/* Title */}
        <Grid item xs={12} className={classes.titleSectionDiv}>
          <PageTitle title={`Request Approval for Express POS - ${posNo} - ${configTab.zoneName || ""} `} />
        </Grid>

        <Grid item xs={12}>
          <Card className={classes.slotCardStyle}>
            <CardContent className={classes.slotCardContentStyle}>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography className={classes.dateSearchTitleSpanStyle}>{`Implemantation time for changes`}</Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/*  */}
              {!isEmptyOrNull(dateObject?.activationDatelabel) && dateObject?.isDateValid && (
                <React.Fragment>
                  <Grid item xs={12} className={classes.titleSectionDiv}>
                    {!isEmptyOrNull(configTab?.zoneId) && isArrayValid(configTab?.slotsGeneratorForms) && (
                      <RenderExpressConfigurationSlotsAccordion
                        classes={classes}
                        configTab={configTab}
                        makeSlotEditable={makeSlotEditable}
                        deleteTemplateSlot={deleteTemplateSlot}
                        addNewTemplateSlot={addNewTemplateSlot}
                        handleOnDemandServiceTimeChange={handleOnDemandServiceTimeChange}
                        handleIndividualSlotFieldsChange={handleIndividualSlotFieldsChange}
                        // Bulk Update
                        bulkUpdatedDays={stateObj.configurationBulkUpdatedObj.bulkUpdatedDays}
                        handleBulkUpdateAction={handleBulkUpdateAction}
                        resetCurrentConfigurationAfterBulkUpdateRevert={resetCurrentConfigurationAfterBulkUpdateRevert}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} className={classes.messageGridItemStyle}>
                    <Accordion defaultExpanded={true} className={classes.accordionStyle}>
                      <AccordionSummary expandIcon={<ExpandMoreAccordianIcon />} className={classes.accordionSummaryStyle}>
                        <Grid container alignItems="center">
                          <Grid>
                            <Typography className={classes.accordionTitle}>
                              Approver Comment <span className={classes.accordionTitleNoteStyle}>(optional)</span>
                            </Typography>
                          </Grid>
                        </Grid>
                      </AccordionSummary>
                      <AccordionDetails className={classes.accordionDetailsStyle}>
                        <CustomTextArea
                          label={""}
                          name={"requesterComments"}
                          value={stateObj.requesterComments}
                          placeholderText={"Message for Approver (Max 200 characters)"}
                          handleChange={handleCommentInputChange}
                          disabled={false}
                        />
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                </React.Fragment>
              )}

              {!isEmptyOrNull(dateObject?.data_present_obj?.requestId) && (
                <Card className={classes.errorCardStyle}>
                  <CardContent>
                    <Typography className={classes.errorTextSpanStyle}>
                      {`A request ${dateObject.data_present_obj.requestId} is already raised for this implementation date by ${dateObject.data_present_obj.requester ?? "Admin"}. Please request action on the same.`}
                    </Typography>
                  </CardContent>
                </Card>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Footer */}
        <RenderFooterButtons classes={classes} serviceData={express} navigate={navigate} posDetails={posDetails} send_request_for_approval={send_request_for_approval} dateObject={dateObject} />
      </Grid>

      <BulkUpdateExpressPopUp
        popUpOpenFlag={stateObj.openBulkUpdateConfirmationPopUp}
        currentConfiguration={stateObj.currentBulkUpdateConfigurationSummary}
        configuredDays={stateObj.configuredDays}
        selctedDays={stateObj.selctedDays}
        currentDay={stateObj.currentDay}
        handleClose={handleCloseBulkUpdateConfimationPopUp}
        handleDaySelectedForBulkUpdate={handleDaySelectedForBulkUpdate}
        handleBulkUpdateConfirmAction={handleBulkUpdateConfirmAction}
      />
    </>
  );
};

export default React.memo(NewExpressRequest);
